module.exports = __webpack_public_path__ + "static/media/leaderboard@3x.1d8b614b.png";